import React from "react"
import { browserHistory } from "react-router"
import Menu from "material-ui/Menu"
import MenuItem from "material-ui/MenuItem"
import strings from "../../localization/strings"
import * as permissionHelper from "../../helpers/permissionHelper"
import AuthenticationStore from "../../stores/AuthenticationStore"
import AppStateStore from "../../stores/AppStateStore"
let navItems = ["Posted_Schedules", "Schedule_Planners", "Master_Schedules", "Schedule_Templates", "Pattern_Templates", "Shift_Templates"]
interface IProps {
	filter: string
}
const ScheduleLeftNav: React.SFC<IProps> = (props: IProps) => {
	if (AppStateStore.hideSchedulePatternTemplate) {
		navItems = navItems.filter(item => item !== "Pattern_Templates")
	}
	const viewAccountSchedulePermission = permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.ViewAccountSchedule)
	const viewSchedulePermission = permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.ViewSchedule)
	if (!viewAccountSchedulePermission) {
		navItems = navItems.filter((item) => !["Shift_Templates", "Pattern_Templates", "Schedule_Templates"].includes(item))
	}
	if (!viewSchedulePermission) {
		navItems = navItems.filter((item) => !["Master_Schedules", "Schedule_Planners", "Posted_Schedules"].includes(item))
	}
	let filter = props.filter
	if (props.filter === "planner") {
		filter = "schedule_planners"
	}
	if (props.filter === "posted") {
		filter = "posted_schedules"
	}
	if (props.filter === "master") {
		filter = "master_schedules"
	}

	return (
		<Menu
			style={{
				backgroundColor: AppStateStore.getFrontEndSettings().UISettings.MenuSelectedBackgroundColor,
				padding: 0
			}}
		>
			{navItems.map((item, index) =>
				<MenuItem
					data-intercom-target={`menu-Schedules-${strings[item].split(" ").join("-")}`}
					primaryText={strings[item]}
					style={{color: filter === item.toLowerCase() ? AppStateStore.getFrontEndSettings().UISettings.MenuSelectedTextColor : AppStateStore.getFrontEndSettings().UISettings.MenuIconColor}}
					value={item}
					key={index}
					onClick={() => browserHistory.push("/schedule/" + item.toLowerCase())}
				/>
			)}
		</Menu>
	)
}

export default ScheduleLeftNav
